import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useId, useState } from "react";
import { Button } from "./button.js";
import { Alert } from "./feedback.js";
import { Input, Label } from "./form.js";
import { Dialog } from "./overlays.js";
/**
 * Büyük/küçük harften bağımsız karşılaştırma için katlama. Türkçedeki dört "i" (I, ı, İ, i) TEK harfe indirgenir:
 * aksi hâlde "IST01" kodunu "ist01" yazan kullanıcı, yerel ayara göre eşleşmeyebilir ("I" → "ı").
 */
export function foldForComparison(value) {
    return value.trim().replace(/[Iıİ]/g, "i").toLowerCase();
}
export function ConfirmDialog({ open, onOpenChange, title, description, confirmLabel = "Onayla", cancelLabel = "Vazgeç", tone = "default", confirmationText, onConfirm, children, }) {
    const inputId = useId();
    const [typed, setTyped] = useState("");
    const [pending, setPending] = useState(false);
    useEffect(() => {
        if (!open)
            setTyped("");
    }, [open]);
    const matches = !confirmationText || foldForComparison(typed) === foldForComparison(confirmationText);
    async function handleSubmit(event) {
        event.preventDefault();
        if (!matches || pending)
            return;
        setPending(true);
        try {
            await onConfirm();
            onOpenChange(false);
        }
        finally {
            setPending(false);
        }
    }
    return (_jsx(Dialog, { open: open, onOpenChange: (next) => !pending && onOpenChange(next), title: title, description: description, dismissible: !pending, children: _jsxs("form", { onSubmit: (event) => void handleSubmit(event), className: "grid gap-4", children: [children, confirmationText ? (_jsxs("div", { className: "grid gap-1.5", children: [_jsxs(Label, { htmlFor: inputId, children: ["Onaylamak i\u00E7in ", _jsx("span", { className: "font-mono font-semibold", children: confirmationText }), " yaz\u0131n"] }), _jsx(Input, { id: inputId, value: typed, onChange: (event) => setTyped(event.target.value), autoComplete: "off", autoFocus: true })] })) : null, _jsxs("div", { className: "flex flex-col-reverse gap-2 sm:flex-row sm:justify-end", children: [_jsx(Button, { variant: "outline", onClick: () => onOpenChange(false), disabled: pending, children: cancelLabel }), _jsx(Button, { type: "submit", variant: tone === "danger" ? "destructive" : "primary", disabled: !matches, loading: pending, children: confirmLabel })] })] }) }));
}
/** Hassas işlem öncesi yeniden kimlik doğrulama (step-up). Görsel bileşendir; API çağrısını çağıran sağlar. */
export function StepUpAuthDialog({ open, onOpenChange, method, onVerify, onVerified, }) {
    const inputId = useId();
    const [value, setValue] = useState("");
    const [error, setError] = useState(null);
    const [pending, setPending] = useState(false);
    useEffect(() => {
        if (!open) {
            setValue("");
            setError(null);
        }
    }, [open]);
    async function handleSubmit(event) {
        event.preventDefault();
        setPending(true);
        setError(null);
        try {
            await onVerify(value);
            onOpenChange(false);
            onVerified?.();
        }
        catch (caught) {
            setError(caught instanceof Error ? caught.message : "Doğrulama başarısız oldu.");
        }
        finally {
            setPending(false);
        }
    }
    return (_jsx(Dialog, { open: open, onOpenChange: onOpenChange, title: "Kimli\u011Finizi do\u011Frulay\u0131n", description: "Bu hassas bir i\u015Flem. Devam etmek i\u00E7in kimli\u011Finizi yeniden do\u011Frulaman\u0131z gerekiyor.", children: _jsxs("form", { onSubmit: (event) => void handleSubmit(event), className: "grid gap-4", children: [error ? _jsx(Alert, { tone: "danger", children: error }) : null, _jsxs("div", { className: "grid gap-1.5", children: [_jsx(Label, { htmlFor: inputId, children: method === "code" ? "Doğrulama kodu" : "Parolanız" }), _jsx(Input, { id: inputId, type: method === "code" ? "text" : "password", inputMode: method === "code" ? "numeric" : undefined, autoComplete: method === "code" ? "one-time-code" : "current-password", value: value, onChange: (event) => setValue(event.target.value), required: true, autoFocus: true })] }), _jsxs("div", { className: "flex justify-end gap-2", children: [_jsx(Button, { variant: "outline", onClick: () => onOpenChange(false), disabled: pending, children: "Vazge\u00E7" }), _jsx(Button, { type: "submit", loading: pending, children: "Do\u011Frula ve devam et" })] })] }) }));
}
//# sourceMappingURL=dialogs.js.map